/* eslint-disable */
import React, { FC, useEffect } from "react";
import "uikit/dist/css/uikit.min.css";
import "uikit/dist/js/uikit";
import Routes from "./routes/Routes";
import { BrowserRouter as Router } from "react-router-dom";
import "./index.css";
import { light, dark, getThemeVal } from "./utils/themes";
import { RootState } from "./store/reducers";
import { connect } from "react-redux";
import { Track } from "./models/track";
import { playOrPause, nextSong, prevSong } from "./store/actions/audio";
// import cors from "cors"
import { setTheme } from "./store/actions";

interface IAProps {
  lightTheme: boolean;
  current: Track;
  playOrPause: Function;
  nextSong: Function;
  prevSong: Function;

  // setFingerprint: Function
}

const App: FC<IAProps> = ({
  lightTheme,
  nextSong,
  prevSong,
  playOrPause,
  // setFingerprint,
}) => {
  // cors({ origin: true })

  useEffect(() => {
    let mounted = true;
    const keys: [string, string] = ["", ""];

    // setFingerprint()

    document.body.addEventListener(`keypress`, (e: KeyboardEvent) => {
      switch (e.key) {
        case " ":
          if (e.ctrlKey) playOrPause();
          break;
        case "ArrowRight":
          nextSong();
          break;
        case "ArrowLeft":
          prevSong();
          break;
        default:
          break;
      }
    });

    if (mounted) {
      let lval = localStorage.getItem("isLight");
      let isLight: boolean = lval === "false" ? false : true;

      setTheme(isLight);

      if (isLight) {
        for (let val in light) {
          document.documentElement.style.setProperty(
            `${val}`,
            getThemeVal(light, val),
          );
        }
      } else {
        for (let val in dark) {
          document.documentElement.style.setProperty(
            `${val}`,
            getThemeVal(dark, val),
          );
        }
      }
    }

    return () => {
      mounted = false;
    };
  }, [lightTheme]);

  return (
    <Router>
      <Routes />
    </Router>
  );
};

const mapStateToProps = (state: RootState) => ({
  lightTheme: state.data.lightTheme,
  current: state.songs.current,
});

export default connect(mapStateToProps, {
  playOrPause,
  nextSong,
  prevSong,
  // setFingerprint,
})(App); //connect(null , { getData, getPlaylists })(App)
